// "Kansrijk" — het label bij regelingen (ownerwens 08-10-2026).
//
// Tot 08-10 las de gebruiker overal "afgeleide suggestie, geen beoordeling van
// jouw situatie". Wat hij nu leest is "Kansrijk", met deze uitleg als tooltip
// (hover én focus). Inhoudelijk verandert er niets: het blijft een afgeleide
// suggestie op sector, status en vorm, nooit een kans of een percentage.
//
// ÉÉN BRON. De backend levert beide uit config/funding.yaml#pasmaat
// (`label`, `label_uitleg` → /api/funding/voor `label` en `labelUitleg`).
// Deze twee constanten spiegelen dat voor plekken zonder API-antwoord (laden,
// fout, de Plan-tab-herkomst) en als terugval; een test vergelijkt ze met de
// contractfixture docs/contracts/fixtures/api-funding-voor.json, en een
// backendtest die fixture met de config.

export const KANSRIJK_LABEL = "Kansrijk";

export const KANSRIJK_UITLEG =
  "Kansrijk: deze regeling past bij de sector (en de vorm van de kans, als die bekend is), " +
  "is nu open of opent binnen 90 dagen, en staat hoog op bedrag, eenvoud en timing. " +
  "Het is geen beoordeling van jouw situatie: check de voorwaarden bij de verstrekker.";
